import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { installmentsStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
  isUpfrontPaymentRequiredForTrial,
}) =>
  priceType === paywallPriceTypes.installments &&
  hasUpfrontPayment &&
  hasTrialPeriod &&
  !isUpfrontPaymentRequiredForTrial;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  currency,
  trialPeriodDays,
  watch,
}) => {
  const totalAmount = mapCurrencyAmountStrToInt(watch("amount"));
  const upfrontPaymentAmount = mapCurrencyAmountStrToInt(
    watch("upfront_payment_amount"),
  );
  const installmentsCount = parseInt(watch("installments_count"));
  const installmentAmount = Math.round(
    (totalAmount - upfrontPaymentAmount) / installmentsCount,
  );
  const intervalType = watch("billing_frequency");

  // Locale variables
  const count = installmentsCount;
  const member_free_trial_phrase = t(
    [localeRoot, "phrases", "member_free_trial"],
    {
      count: trialPeriodDays,
    },
  );
  const then_upfront_amount_phrase = t(
    [localeRoot, "phrases", "then_upfront_amount"],
    {
      amount: formatPaywallCurrencyAmount(currency, upfrontPaymentAmount),
    },
  );
  const total_amount_phrase = t([localeRoot, "phrases", "total_amount"], {
    amount: formatPaywallCurrencyAmount(currency, totalAmount),
  });

  return [
    ["trial_then_upfront_then_installments", intervalType],
    {
      count,
      member_free_trial_phrase,
      then_upfront_amount_phrase,
      installment_amount: formatPaywallCurrencyAmount(
        currency,
        installmentAmount,
      ),
      total_amount_phrase,
    },
  ];
};

export const trialThenUpfrontThenInstallments: NoticeScenario = {
  matcher,
  stateValidator: installmentsStateValidator,
  messagePropsResolver,
};
